<div class="contact-content">
    <div class="back-button">
        <mat-icon routerLink="/specialitypricelist">arrow_back</mat-icon>
    </div>
    <div class="title">
        <h3>{{ specialityName | uppercase }} ÁRLISTA MÓDOSÍTÁSA</h3>
    </div>
    <div class="add-new-speciality">
        <div class="search-bar">
            <div class="search-tool">
                <input type="search" placeholder="Tétel neve" [(ngModel)]="searchText" />
                <div class="icon">
                    <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search" />
                </div>
            </div>
        </div>
    </div>
    <div class="contact-form">
        <form novalidate [formGroup]="priceListForm!">
            <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                @for (item of examinationList | filter: searchText; track item; let i = $index) {
                <div class="array" formArrayName="items" cdkDrag>
                    <div class="form-element" [ngStyle]="
                                i % 2 === 0
                                    ? { background: 'white', display: 'flex' }
                                    : { background: '#efeff5', display: 'flex', width: '100%' }
                            " [formGroupName]="i">
                        <div class="field-container">
                            <div class="field">
                                <span> {{ i + 1 }}. Tétel neve</span>
                                <div class="data">
                                    <textarea type="text" formControlName="name" placeholder="Tétel neve"></textarea>
                                </div>
                            </div>
                        </div>
                        @if (item.price) {
                        <div class="field-container">
                            <div class="field">
                                <span>Tétel ára ( Ft )</span>
                                <div class="data">
                                    <input type="number" formControlName="price" placeholder="Tétel ára" />
                                </div>
                            </div>
                            <mat-icon [ngStyle]="{ cursor: 'pointer' }"
                                (click)="openDeleteExaminationDialog(item.id!)">delete_forever</mat-icon>
                        </div>
                        }
                        @if (item.minPrice) {
                        <div class="field-container">
                            <div class="field">
                                <span>Tétel minimum ára ( Ft )</span>
                                <div class="data">
                                    <input type="number" formControlName="minPrice" placeholder="Tétel ára" />
                                </div>
                            </div>
                        </div>
                        }
                        @if (item.maxPrice) {
                        <div class="field-container">
                            <div class="field">
                                <span>Tétel maximum ára ( Ft )</span>
                                <div class="data">
                                    <input type="number" formControlName="maxPrice" placeholder="Tétel ára" />
                                </div>
                            </div>
                            <mat-icon [ngStyle]="{ cursor: 'pointer' }"
                                (click)="openDeleteExaminationDialog(item.id!)">delete_forever</mat-icon>
                        </div>
                        }
                    </div>
                </div>
                }
            </div>
        </form>
        <div class="field-container" [ngStyle]="{ 'margin-top': '8px' }">
            <div class="field" [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }">
                <div class="data" [ngStyle]="{ 'justify-content': 'center' }">
                    <button type="button" [ngStyle]="{
                            background: '#eee',
                            border: '1px solid #ccc',
                            padding: '8px',
                            'font-weight': 'bold',
                            width: '100%',
                            'border-radius': '4px',
                            cursor: 'pointer'
                        }" [disabled]="!priceListForm?.valid" (click)="updatePriceList()">
                        {{ specialityName | uppercase }} ÁRLISTA MÓDOSÍTÁSA
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>